import React, { useState } from "react";
import { Container, Row, Col, Form, Button, Image } from "react-bootstrap";
import profileIcon from "../assets/user2.png";
import showPasswordIcon from "../assets/show-regular-24.png";
import hidePasswordIcon from "../assets/show-solid-24.png";

const User = ({ setIsLoggedIn }) => {
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword1, setShowPassword1] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);
  const [showPassword3, setShowPassword3] = useState(false);
  const [newPasswordError, setNewPasswordError] = useState(null);
  const [confirmPasswordError, setConfirmPasswordError] = useState(null);

  const logout = () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    localStorage.setItem("userRole", "");
    window.location.href = "/";
  };
  const userName = localStorage.getItem("loggedInUserName");
  const handleOldPasswordChange = (e) => {
    setOldPassword(e.target.value);
  };

  const handleNewPasswordChange = (e) => {
    setNewPassword(e.target.value);
  };

  const handleConfirmPasswordChange = (e) => {
    setConfirmPassword(e.target.value);
    setConfirmPasswordError(null);
  };

  const toggleShowPassword1 = () => {
    setShowPassword1(!showPassword1);
  };

  const toggleShowPassword2 = () => {
    setShowPassword2(!showPassword2);
  };

  const toggleShowPassword3 = () => {
    setShowPassword3(!showPassword3);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (newPassword !== confirmPassword) {
      setConfirmPasswordError("Lozinke se ne poklapaju!");
      return;
    } else if (newPassword.length < 8) {
      setNewPasswordError("Minimum 8 karaktera!");
      return;
    } else if (!/[A-Z]/.test(newPassword)) {
      setNewPasswordError("Mora biti jedno veliko slovo!");
      return;
    } else if (!/[0-9]/.test(newPassword)) {
      setNewPasswordError("Mora biti jedan broj!");
      return;
    } else if (!/[^a-zA-Z0-9]/.test(newPassword)) {
      setNewPasswordError("Mora biti jedan specijalni karakter!");
      return;
    }

    // Send updated email and password to the server
    updatePassword();
  };

  const updatePassword = async () => {
    try {
      const response = await fetch(
        "https://radojicictijanaa.pythonanywhere.com/api/accounts/",
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
          body: JSON.stringify({
            old_password: oldPassword,
            new_password: newPassword,
          }),
        }
      );

      if (response.ok) {
        console.log("Password updated successfully");
        // Clear the input fields
        setOldPassword("");
        setNewPassword("");
        setConfirmPassword("");
      } else {
        // Handle unauthorized or error response
        console.log("Error updating password:", response.status);
      }
    } catch (error) {
      console.log("Error updating password:", error);
    }
  };

  return (
    <Container style={{ marginTop: "2%" }}>
      <Row className="justify-content-center">
        <Col xs={12} className="text-center mb-3 p-4 bg-light">
          <Image src={profileIcon} height="100" width="100" roundedCircle />
        </Col>
        <Row>
          <Form onSubmit={handleSubmit}>
            <Form.Group controlId="formUserEmail">
              <Form.Label className="text-center">
                <span
                  style={{
                    fontWeight: "bold",
                    textTransform: "uppercase",
                  }}
                >
                  {userName}
                </span>
              </Form.Label>{" "}
              <Button
                style={{
                  background: "darkred",
                  border: "none",
                  float: "right",
                }}
                onClick={logout}
              >
                Izloguj se
              </Button>
            </Form.Group>
          </Form>
        </Row>
      </Row>
    </Container>
  );
};

export default User;
